module.exports = __webpack_public_path__ + "static/img/5g (3).acc0cba0.png";